import { InvoiceListItem } from '../store/types/invoice';
import { getApiUrl } from './env';

const buildInvoiceDocumentUrl = (invoice: InvoiceListItem): string =>
  `${getApiUrl()}/api/organizations/${invoice.organizationId}/invoices/${
    invoice.id
  }/document`;

export default buildInvoiceDocumentUrl;
